import { useSelector } from 'react-redux'
import { getAttendantsMap, getManagerIds } from '../../selectors/attendant'
import { useMemo } from 'react'

const useManagerCodes = () => {
  const attendantsMap = useSelector(getAttendantsMap)
  const attendants = useMemo(() => Object.values(attendantsMap), [attendantsMap])
  const managerIds = useSelector(getManagerIds)

  const getManagerApprovalCodes = () => {
    if (!managerIds) return []

    const managers = managerIds.map((managerId) => {
      return attendants.find((attendant) => {
        return attendant.employeeId === managerId
      })
    })

    return managers.reduce((map, manager) => {
      if (manager && manager.pinNumber && manager.uuid) {
        map[manager.pinNumber] = manager.uuid
      }
      return map
    }, {})
  }

  return { getManagerApprovalCodes }
}

export default useManagerCodes
